import * as api from '../constants/api'
import callApi from './http'

const categoryMain = async () => await callApi(api.category_main)

const categoryDetails = async (id) => await callApi(getCategoryDetailsApiById(id))

const getCategoryDetailsApiById = (id) => {
    switch (id) {
        case "1":
            return api.introduction
        case "2":
            return api.what_wrestler_should_know
        case "3":
            return api.technique
        case "4":
            return api.sport_pathology
        case "5":
            return api.bodybuilding_training
        case "6":
            return api.nutrition_sports_supplements
        case "7":
            return api.practice_with_kesh
        case "8":
            return api.warm_up_exercises
        case "9":
            return api.psychology_motivation
        case "10":
            return api.shading
        case "11":
            return api.competitions
        case "12":
            return api.athletes_sexual_issues
        case "31":
            return api.technique_undercover
        case "32":
            return api.technique_guarding
        case "33":
            return api.technique_yekdast_yekpa
        case "34":
            return api.technique_undercover_continue
        case "35":
            return api.technique_prevalence
        case "36":
            return api.technique_interception_defense
        case "37":
            return api.technique_head_and_neck
        case "38":
            return api.technique_working_hands
        case "39":
            return api.technique_sitting_on_buttocks
        case "310":
            return api.technique_techniques_in_soil
        case "311":
            return api.technique_standing_techniques
        default:
            return api.category_main
    }
}

export {
    categoryMain,
    categoryDetails
}